/** Money crosses every billing wire, so it ships a schema (design 12.2). */
import { z } from "zod";
export const CurrencyCodeSchema = z.literal("EUR");
/**
 * `z.number().int()` is a safe-integer check: a fractional amount is rejected rather than
 * rounded, which is design 4.1 S4's "never a float" expressed at the boundary.
 */
export const MoneySchema = z
    .object({
    amountMinor: z.number().int(),
    currency: CurrencyCodeSchema,
})
    .strict();
/** Millionths of a minor unit (`cost_rate.unit_cost_micro`). */
export const MicroMinorSchema = z
    .object({
    amountMicroMinor: z.number().int(),
    currency: CurrencyCodeSchema,
})
    .strict();
//# sourceMappingURL=money.schema.js.map